import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';



const styles = theme => ({
  textfield: {
    marginBottom: theme.spacing.unit * 3,
    width: '100%',
  },
});


class NotesAndDigitalForm extends React.Component {

  render = () => {
    const {classes, order, actions} = this.props

    return (
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body1" style={{marginBottom: `2em`}}>
              Please add any special instructions or comments regarding this order.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              defaultValue={order.specialRequests}
              rows={10}
              multiline
              variant="outlined"
              className={classes.textfield}
              onChange={e => actions.updateOrder(order, {specialRequests: e.target.value})}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

NotesAndDigitalForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotesAndDigitalForm);
